module.exports = __webpack_public_path__ + "img/Rain-Volume-unscreen.68b9dc5a.gif";